module.exports = __webpack_public_path__ + "img/warn.efeb4f94.svg";